// extracted by mini-css-extract-plugin
export var inline = "_v4-0";